module.exports = __webpack_public_path__ + "img/success.88218de6.svg";